import React, {CSSProperties, ReactNode, useCallback, useEffect} from 'react';
import AbstractDeclarantStore from "../../stores/AbstractDeclarantStore";
import TwsSyncButton from "./twsSyncButton";

type TwsSyncContainerProps = {
  store: AbstractDeclarantStore;
};

const textStyles: CSSProperties = {
  textAlign: 'center',
  lineHeight: '12px',
  fontSize: '12px',
  padding: 0,
  margin: 0,
};


const TwsSyncContainer = ({ store }: TwsSyncContainerProps) => {
  const [dateString, setDateString] = React.useState<string>('');

  useEffect(() => {
    if(store.isLoadingTableData) {
      setDateString('Loading...');
    } else {
      const newDate: Date = new Date(store.lastTwsUpdateDate);
      if(!Number.isNaN(newDate.getTime())) {
        setDateString(newDate.toLocaleString('ru-RU'));
      }
    }
  }, [store.lastTwsUpdateDate, store.isLoadingTableData]);

  return (
    <div
      style={{
        padding: '4px 16px 4px 10px',
        background: 'white',
        position: 'relative',
        minWidth: '220px',
      }}
      className={'border'}
    >
      <div
        style={{
          alignItems: 'center',
        }}
        className={'row-container'}
      >
        <p
          style={{
            ...textStyles,
            fontWeight: 'bold',
          }}
        >
          TWS sync:
        </p>
        <TwsSyncButton store={store} />
        <TwsSyncButton store={store} existingOnly />
        <p
          style={{...textStyles}}
        >
          Last Update: {dateString}
        </p>
      </div>
    </div>
  );
};

export default TwsSyncContainer;